import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 标签文章列表接口
export function getLaberArticleList(params, id) {
    var sign = getRequest(params);
    return request({
        url: `/v4/topics/${id}/articles`,
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}
// 筛选标签列表接口
export function getLaberTagsList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/tags',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}
// 搜索-标签-详情接口
export function getTagsDetailList(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/topics/${id}`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 搜索-杂志-杂志栏目详情接口
export function getMagazineDetailList(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/columns/${id}`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 搜索-杂志-栏目文章列表接口
export function getMagazineList(params, id) {
    var sign = getRequest(params);
    return request({
        url: `/v4/columns/${id}/articles`,
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}

// 关键词列表
export function getHotwords() {
    var sign = getRequest({});
    return request({
        url: '/v4/hotwords',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}

// 文章搜索接口
export function getSearch(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/pg_search_documents',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign,
            'ClientVersion': '4.0.0',
            'ClientPlatform': 'PC'
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/search.js